import axios from 'axios';
import { get } from 'lodash';
// config
import { baseURL } from 'src/config-global';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: baseURL });

// axiosInstance.interceptors.response.use(
//   (res) => res,
//   (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
// );

// export default axiosInstance;

// ----------------------------------------------------------------------

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);
export default axiosInstance;
// ----------------------------------------------------------------------
// export const fetcher = async (args) => {
//   const [ url, config ] = Array.isArray(args) ? args : [ args ];
//   const res = await axiosInstance.get(url, {
//     headers: apiHeader,
//     ...config
//   });
//   return res.data;
// };

export const fetcher = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosInstance.get(url, { ...config });

  return res.data;
};



// ----------------------------------------------------------------------
export const tokenGetter = () => {
  const searchParams = new URLSearchParams(window.location.search);
  // console.log("token getter function")
  return `Bearer ${searchParams.get('token') || localStorage.getItem('accessToken')}` || '';
};
export const currentprojectid = () => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get('project_id') || localStorage.getItem('projectId') || ''
};
export const currentCompanyId = () => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get('company_id') || localStorage.getItem('companyId') || '';
};
export const simpleHeader = {
  Authorization: tokenGetter(),
  currentprojectid: currentprojectid(),
  currentCompanyId: currentCompanyId(),
}

export const apiHeader = {
  Accept: 'application/json',
  Authorization: tokenGetter(),
  currentCompanyId: currentCompanyId(),
  currentProjectId: currentprojectid(),
}
export const apiPostHeader = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
  Authorization: tokenGetter(),
  currentCompanyId: currentCompanyId(),
  currentProjectId: currentprojectid(),
}

export const multipartPartFormDataHeader = {
  'Content-Type': 'multipart/form-data',
  Accept: 'application/json',
  Authorization: tokenGetter(),
  currentCompanyId: currentCompanyId(),
  currentProjectId: currentprojectid(),
}
const userProjectsID = currentprojectid();
// ----------------------------------------------------------------------
// ----------------------------------------------------------------------

export const endpoints = {
  admin_dashboard: {
    website: {
      home_page: {
        hero_section: '/admin/web-pages/home-page'
      },
      solution_page: {
        solution_section: '/admin/web-pages/solution-page'
      },
      challenge_page: {
        challenge_section: '/admin/web-pages/challenge-page'
      },
      sector_page: {
        sector_section: '/admin/web-pages/sector-page'
      },
      role_page: {
        role_section: '/admin/web-pages/role-page'
      },
      contractor_page: {
        contractor_section: '/admin/web-pages/contractor-page'
      },
      product_feature_page: {
        product_feature_section: '/admin/web-pages/product-page'
      },
      construction_page: {
        construction_section: '/admin/web-pages/construction-page'
      },
      project_management_main_page: {
        project_management_main_section: '/admin/web-pages/project-management-page'
      },
      field_management_page: {
        field_management_section: '/admin/web-pages/field-management-page'
      },
      resource_planning_page: {
        resource_planning_section: '/admin/web-pages/resource-planning-page'
      },
      time_management_page: {
        time_management_section: '/admin/web-pages/time-management-page'
      },


      // safety checklist page
      safety_checklist_page: {
        safety_checklist_section: '/admin/web-pages/safety-checklist-page'
      },
      // checklist page
      daily_checklist_page: {
        daily_checklist_section: '/admin/web-pages/daily-checklist-page'
      },
      //communication management page
      communication_management_page: {
        communication_management_section: '/admin/web-pages/communication-management-page'
      },
      //schedule performace page
      schedule_performance_page: {
        schedule_performance_section: '/admin/web-pages/schedule-performance-page'
      },
      //cost performace page
      cost_performance_page: {
        cost_performance_section: '/admin/web-pages/cost-performance-page'
      },
      //close out page
      close_out_page: {
        close_out_section: '/admin/web-pages/close-out-page'
      },
      //document control page
      document_control_page: {
        document_control_section: '/admin/web-pages/document-control-page'
      },
      //financial management page
      financial_management_page: {
        financial_management_section: '/admin/web-pages/financial-management-page'
      },
      // report & analytics page
      report_analytics_page: {
        report_analytics_section: '/admin/web-pages/report-analytics-page'
      },
      // tech product & integration page
      technology_integration_page: {
        technology_integration_section: '/admin/web-pages/tech-product-integration-page'
      },
      //user management page
      user_management_page: {
        user_management_section: '/admin/web-pages/user-management-page'
      },
      //office management page
      office_management_page: {
        office_management_section: '/admin/web-pages/office-management-page'
      },
      //pre construction page
      pre_construction_page: {
        pre_construction_section: '/admin/web-pages/pre-construction-page'
      },
      //post construction page
      post_construction_page: {
        post_construction_section: '/admin/web-pages/post-construction-page'
      },
      //software development page
      software_development_page: {
        software_development_section: '/admin/web-pages/software-development-page'
      },

    },

    dashboard: {
      get_user_counts: "/admin/dashboard/user-count",
      get_analytics: "/admin/dashboard/analytics",
      get_wakeups: "/admin/play-analytics/excessive-wakeups",
      get_crashes: "/admin/play-analytics/crash-rate",
      get_anr: "/admin/play-analytics/anr-rate",
    },
    register_user: {
      get_list: '/admin/register-users',
      delete: '/admin/delete-register-users',
      change_status: '/admin/register-users'
    },
    vendor_user: {
      get_list: '/admin/vendor-profiles',
      change_status: '/admin/vendor-profile',
      import_vendors: '/import-network-vendors'
    },
    roles_and_permissions: {
      upadte_permission: '/admin/roles',
      get_list: '/admin/roles',
      remove_role: '/admin/roles',
      create_role: '/admin/roles',
      get_permissions: '/admin/permissions',
    },
    admin_user: {
      post_user: '/admin-users',
      delete: '/admin-users',
      user_role: {
        get_list: '/admin-users',
      },
      change_status: '/admin-users'
    },
    teachnical_database: {
      cost_codes: {
        get_list: '/admin/cost-code-categories',
        get_activities_list: '/admin/cost-code-category',
        post_list: '/admin/cost-code-categories',
        post_list_activity: '/admin/cost-code-category',
        show_list: '/admin/cost-code-category',
        delete: '/admin/cost-code-categories',
        import_categories: '/admin/import-cost-code-categories',
        import_activities: '/admin/cost-code-category',
        delete_activities: '/admin/cost-codes',
      },
      materials_categories: {
        get_list: '/admin/material-categories',
        post_list: '/admin/material-categories',
        delete: '/admin/material-categories',
        show_list: '/admin/material-category',
        show_list_create: '/admin/material-category',
        import_activities: '/admin/material-category',
      },
      equipments_categories: {
        get_list: '/admin/equipment-categories',
        post_list: '/admin/equipment-categories',
        show_list: '/admin/equipment-category',
        show_list_create: '/admin/equipment-category',
        delete: '/admin/equipment-categories',
        import_activities: '/admin/equipment-category',

      },
      stt_folders: {
        get_categories: '/admin/stt-categories',
        post_categories: '/admin/stt-categories',
        show_list: '/admin/stt-categories',
        show_list_create: '/admin/stt-categories',
      },
      trades: {
        get_list: '/admin/trades',
        post_list: '/admin/trades',
        import_trades: '/admin/import-trades',
      },
      trade_work_title: {
        get_list: '/admin/trade-work-titles',
        post_list: '/admin/trade-work-titles',
        import_trades_work_title: '/admin/import-trade-work-titles',
      },
      bids: {
        get_list: '/admin/bid-links',
      },
    },
    product_updates: {
      newsletter: {
        get_code: '/admin/communication-email/test-template',
        get_list: '/admin/communication-emails',
        post_list: '/admin/communication-emails',
        delete: '/admin/communication-emails',
        get_email_modal_details: '/admin/communication-email/recipients',
        post_modal_images: '/admin/communication-email/upload-files',
        test_image_post_req: '/admin/communication-email/test-template',
        filter_date_email_send: '/admin/communication-email/send',
        get_modal_images: '/admin/communication-email/images',
        remove_modal_images: '/admin/communication-email/remove-image',
        schedule_email: '/admin/communication-email/update-status',
      },
    },
    marketing_management: {

      board: {
        crud_stage: '/admin/kanban-stages', //upadte method put , delete id
        card_cretae: '/admin/kanban-stages',
        drag_card: '/admin/kanban-stages/cards',
        delete_card: '/admin/cards',
        card_upadate: '/admin/cards',
      },
      timeline: {
        get_cards: '/admin/all-cards',
      },
      marketing_tools: {
        get_all_compains: '/admin/campaign',
      },

    },
    support_tickets: {
      get_list: '/admin/bug-reports',
      post_list: '/admin/bug-reports',
      delete: '/admin/bug-reports',
      change_status: '/admin/bug-reports',
      assign_ticket: '/admin/bug-reports',
      get_messages: '/admin/bug-reports',
      post_messages: '/admin/bug-reports',

    },
    packages_plans: {
      module_features: {
        get_list: '/admin/product-modules',
        post_list: '/admin/product-modules',
        delete: '/admin/product-modules',// pass id
      },
      plans: {
        get_list: '/admin/product-plans',
        post_list: '/admin/product-plans',
        delete: '/admin/product-plans',
        get_fixed_values: '/admin/product-plan-fixed-costs',
        show_plans: '/admin/product-plans',
        create_addons: '/admin/product-plans',
      }
    },
  },

  chat: '/api/chat',
  kanban: '/api/kanban',
  calendar: '/api/calendar',

  auth: {
    me: '/admin/profile',
    login: '/admin/login',
    register: '/api/auth/register',
    verify_otp: '/admin/verify-otp',
  },
  mail: {
    list: '/api/mail/list',
    details: '/api/mail/details',
    labels: '/api/mail/labels',
  },
  post: {
    list: '/api/post/list',
    details: '/api/post/details',
    latest: '/api/post/latest',
    search: '/api/post/search',
  },
  product: {
    list: '/api/product/list',
    details: '/api/product/details',
    search: '/api/product/search',
  },
};
